export default {
  SET_SERVICE_CONFIG: '@MYYOLA/SET_SERVICE_CONFIG',
};
